import { render, staticRenderFns } from "./Sit_Stand.vue?vue&type=template&id=f7f41584&"
import script from "./Sit_Stand.vue?vue&type=script&lang=js&"
export * from "./Sit_Stand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports